import {linkModel} from "framework/mobx-integration";
import {getStore, GridStoreHolder} from "controls/grid/utils/getStore";

export function linkGridCustomData(holder: GridStoreHolder<any>, name: string) {
	const store = getStore(holder)
	return linkModel(store?.state?.customData, name)
}
